"use client";

export default function HeaderBackgroundImage() {
  const corner_image = "/images/right-corner-block.png";
  const dimOnDark = "[html[data-appearance=dark]_&]:opacity-90";

  return (
    <>
      <div className="relative h-fit max-h-[23vh] w-full overflow-hidden lg:hidden">
        <img src={corner_image} alt="corner design" className={`w-full translate-y-[-25%] -rotate-90 object-cover object-top ${dimOnDark}`} />
      </div>
      <img src={corner_image} alt="corner design" className={`absolute -right-0 -top-0 z-0 hidden w-[60%] lg:block lg:w-[40%] ${dimOnDark}`} />
    </>
  );
}
